import React, { useState } from "react";
import "./header.css";
import "./main.css";
import "../Designs/designs.css";
import { Link, NavLink } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { BiUserCircle } from "react-icons/bi";
import { BsSuitHeartFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { editUser, logoutUser } from "../Features/users/userslice";
import { clearCart } from "../Features/cart/cartslice";

const Header = () => {
  const userLoggedIn = useSelector((state) => state.users.username);
  const noOfMoviesInWishlist = useSelector((state) => state.cart.cart);
  const [edit, setEdit] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [userSetting, setUserSetting] = useState(false);

  const dispatch = useDispatch();

  // if (edit.length >= 10) {
  //   alert("you have reached max character limit");
  // }

  function Logout() {
    dispatch(logoutUser());
    dispatch(clearCart());
  }

  function handleEdit(e) {
    if (edit === "") return;
    e.preventDefault();
    dispatch(editUser(edit));
    setEdit("");
    setShowEdit(false);
    setUserSetting(false);
  }

  function shownavHandler() {
    const nav = document.querySelector(".nav");
    nav.classList.toggle("active");
  }
  function removeNavHandler() {
    const nav = document.querySelector(".nav");
    nav.classList.remove("active");
  }
  return (
    <>
      <header className="header">
        {/* <div className="logo-ham">
          <div className="logo">
            <NavLink className="logo-name" to="/">
              Movies<span className="info">Info</span>
            </NavLink>
          </div> */}
        <div className="hamburger" onClick={shownavHandler}>
          <p className="line"></p>
          <p className="line"></p>
          <p className="line"></p>
        </div>
        {/* </div> */}
        <div className="nav-logo-box">
          <div className="logo">
            <NavLink className="logo-name" to="/">
              Movies<span className="info">Info</span>
            </NavLink>
          </div>
          <nav className="nav">
            <div className="nav__links">
              <NavLink onClick={removeNavHandler} className="link" to="popular">
                Popular
              </NavLink>
              <NavLink onClick={removeNavHandler} className="link" to="rated">
                Top Rated
              </NavLink>
              <NavLink
                onClick={removeNavHandler}
                className="link"
                to="upcoming"
              >
                Upcoming
              </NavLink>
              <NavLink
                onClick={removeNavHandler}
                className="link search_link"
                to="search"
              >
                Search
                <span>
                  <BsSearch />
                </span>
              </NavLink>
            </div>
          </nav>
        </div>
        <div className="user-info-box">
          <div className="user-loggedin-box">
            <p>
              Welcome <span>{userLoggedIn}</span>
              <span onClick={() => setUserSetting(!userSetting)}>
                <BiUserCircle />
              </span>
            </p>
            {userSetting && (
              <>
                {/* <div className="log-out-box">
                  <p onClick={() => setShowEdit(!showEdit)}>Edit</p>
                  <p onClick={() => Logout()}>Logout</p>
                </div> */}
                {userSetting && (
                  <form onSubmit={handleEdit} className="edit-form">
                    <input
                      value={edit}
                      onChange={(e) => setEdit(e.target.value)}
                      type="text"
                      placeholder="Edit Username (max: 10 chars)"
                      maxlength="10"
                      required
                    />
                    <button>Edit</button>
                  </form>
                )}
              </>
            )}
          </div>
          <Link className="wishlist-box" to="/watchlist">
            <BsSuitHeartFill />
            <p className="wishlist-box-items">{noOfMoviesInWishlist.length}</p>
          </Link>
        </div>
      </header>
    </>
  );
};

export default Header;
